export { default } from './euras-pledge-documents';
